import { DataBean } from "../DataBean";

export class PersonDocuments extends DataBean {


    public async getPersonDocumentsCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("TalentERP", "java.util.List_getPersonDocumentsCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }

}